//  * @package         src/components/Dashboard
//  * @author          Riddhi D Parekh
//  * @date            22nd October 2018
//  * @type            Questions Left Component File
//  * @description -   This file renders the html and functionality that renders at left panel when questions tab is selected.
<template>
  <div
    :class="
      all.in_status === vueCommonConfig.SURVEY_PUBLISHED
        ? 'disabledbutton colume_1_option_elements'
        : 'colume_1_option_elements'
    "
  >
    <div class="tab-content"> 
      <div id="tab_option_setting" class="tab-pane fade in active icon-edit">
        <div v-if="favArray.length > 0" class="colume_1_elements">
          <h3>{{ $t("attributes.favourites") }}</h3>
          <!-- <div class="elements_sec"> -->
          <!-- questUpdated === 1 ? $awn.confirm('Do you want to save current question first?',callSaveMethod,callCancelMethod) : -->
          <draggable
            @start="
              (drag = false),
                questUpdated === 1
                  ? $awn.confirm(
                      'Do you want to save current question first?',
                      callSaveMethod,
                      callCancelMethod
                    )
                  : (drag = true)
            "
            class="elements_sec"
            v-model="favArray"
            :move.once="checkMoveOfFavs"
            @add="onAdd"
            :options="{
              group: { name: 'people', pull: 'clone' },
              sort: false,
              handle: '.elements_sec_box',
            }"
          >
            <a
              v-for="(favourite, index) in favArray"
              :key="favourite['in_control_id']"
              :id="favourite['in_control_id']"
              href="#/"
              :class="
                all.in_survey_type == 1 &&
                (favourite['in_control_id'] ===
                  vueQueControlConfig.CONTROL_PHOTO ||
                  favourite['in_control_id'] ===
                    vueQueControlConfig.CONTROL_QR_AND_BARCODE_READER || favourite['in_control_id'] ===
                    vueQueControlConfig.CONTROL_AUDIO || favourite['in_control_id'] ===
                    vueQueControlConfig.CONTROL_VIDEO)
                  ? 'elements_sec_box favourites disable_mobile_control'
                  : 'elements_sec_box favourites'
              "
              :data-id="favourite['in_control_id']"
              :data-controlname="favourite['st_control_name']"
              :data-classname="favourite['st_class_name']"
              @dblclick="
                questUpdated === 1
                  ? $awn.confirm(
                      'Do you want to save current question first?',
                      callSaveMethod,
                      callCancelMethod
                    )
                  : addQuestionOnDoubleClick($event, favourite)
              "
            >
            <div class="element_content">
              <svg height="512pt" viewBox="0 0 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg" v-if="favourite['in_control_id'] == vueQueControlConfig.CONTROL_TIME">
                <path d="m256 0c-141.164062 0-256 114.835938-256 256s114.835938 256 256 256 256-114.835938 256-256-114.835938-256-256-256zm121.75 388.414062c-4.160156 4.160157-9.621094 6.253907-15.082031 6.253907-5.460938 0-10.925781-2.09375-15.082031-6.253907l-106.667969-106.664062c-4.011719-3.988281-6.25-9.410156-6.25-15.082031v-138.667969c0-11.796875 9.554687-21.332031 21.332031-21.332031s21.332031 9.535156 21.332031 21.332031v129.835938l100.417969 100.414062c8.339844 8.34375 8.339844 21.824219 0 30.164062zm0 0"/>
              </svg>
              <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="501.5px" height="520.5px" viewBox="0 -8.5 501.5 520.5" enable-background="new 0 -8.5 501.5 520.5" xml:space="preserve" v-else-if="favourite['in_control_id'] == vueQueControlConfig.CONTROL_TERMS_AND_CONDITIONS">
                <path d="M370.961,229.68c0.852,0,1.699,0.012,2.551,0.027l0.219,0.004c4.777,0.086,9.516,0.395,14.207,0.906V56.41
                  c0-33.309-27.102-60.41-60.41-60.41H65.414C32.102-4,5,23.102,5,56.41v347.473c0,33.313,27.102,60.414,60.41,60.414h175
                  c-15.102-24.27-23.023-51.988-23.023-80.957C217.387,298.61,286.277,229.68,370.961,229.68z M221.656,94.637h89.523
                  c8.285,0,15,6.715,15,15s-6.715,15-15,15h-89.523c-8.281,0-15-6.715-15-15S213.375,94.637,221.656,94.637z M221.656,154.641h89.523
                  c8.285,0,15,6.715,15,15s-6.715,15-15,15h-89.523c-8.281,0-15-6.715-15-15S213.375,154.641,221.656,154.641z M171.281,365.656
                  H81.758c-8.285,0-15-6.715-15-15c0-8.281,6.715-15,15-15h89.523c8.281,0,15,6.719,15,15
                  C186.281,358.942,179.563,365.656,171.281,365.656z M171.281,304.649H81.758c-8.285,0-15-6.715-15-15s6.715-15,15-15h89.523
                  c8.281,0,15,6.715,15,15S179.563,304.649,171.281,304.649z M171.281,244.645H81.758c-8.285,0-15-6.715-15-15s6.715-15,15-15h89.523
                  c8.281,0,15,6.715,15,15S179.563,244.645,171.281,244.645z M171.281,184.641H81.758c-8.285,0-15-6.715-15-15s6.715-15,15-15h89.523
                  c8.281,0,15,6.715,15,15S179.563,184.641,171.281,184.641z M171.281,124.637H81.758c-8.285,0-15-6.715-15-15s6.715-15,15-15h89.523
                  c8.281,0,15,6.715,15,15S179.563,124.637,171.281,124.637z M206.656,229.645c0-8.285,6.719-15,15-15h43.117c8.285,0,15,6.715,15,15
                  s-6.715,15-15,15h-43.117C213.375,244.645,206.656,237.93,206.656,229.645z"/>
                <path d="M459.785,295.942c-23.023-23.43-53.773-36.656-86.582-37.234l-0.215-0.004c-0.676-0.012-1.352-0.023-2.027-0.023
                  c-68.691,0-124.574,55.922-124.574,124.66c0,27.301,8.664,53.227,25.051,74.98c23.785,31.574,60.059,49.68,99.523,49.68
                  c68.691,0,124.574-55.922,124.574-124.66C495.535,350.434,482.84,319.395,459.785,295.942z M424.188,363.074l-47.57,59.301
                  c-2.957,3.684-7.309,5.617-11.711,5.617c-3.059,0-6.137-0.934-8.793-2.855l-35.48-25.707c-6.707-4.859-8.207-14.238-3.344-20.949
                  c4.859-6.707,14.238-8.207,20.945-3.344l23.918,17.328l38.637-48.164c5.184-6.461,14.621-7.496,21.086-2.313
                  C428.336,347.172,429.371,356.614,424.188,363.074z"/>
              </svg>
              <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="26.688px" height="26.563px" viewBox="0 -0.563 26.688 26.563" enable-background="new 0 -0.563 26.688 26.563" xml:space="preserve" v-else-if="favourite['in_control_id'] == vueQueControlConfig.CONTROL_SIGNATURE">
                <g>
                  <g>
                    <path d="M20.127,4.158c0-0.61-0.237-1.184-0.669-1.616l-2.154-2.154c-0.425-0.425-1.029-0.669-1.63-0.669h-0.131v4.57h4.584V4.158
                      L20.127,4.158z"/>
                  </g>
                </g>
                <g>
                  <g>
                    <path d="M14.258,15.438c0.146-0.443,0.4-0.855,0.732-1.189l5.158-5.136V5.813h-5.354c-0.42,0-0.736-0.341-0.736-0.762v-5.332
                      H2.633c-1.26,0-2.285,1.025-2.285,2.285v21.43c0,1.26,1.025,2.285,2.285,2.285h15.209c1.261,0,2.307-1.025,2.307-2.285v-5.686
                      l-0.838,0.817c-0.339,0.336-0.736,0.581-1.184,0.73l-2.422,0.809l-0.369,0.021c-0.61,0-1.188-0.297-1.546-0.795
                      c-0.355-0.494-0.452-1.135-0.259-1.715L14.258,15.438z M4.157,13.43h7.592c0.421,0,0.762,0.341,0.762,0.762
                      s-0.34,0.762-0.762,0.762H4.157c-0.421,0-0.762-0.341-0.762-0.762S3.736,13.43,4.157,13.43z M3.395,11.145
                      c0-0.421,0.341-0.762,0.762-0.762h7.592c0.421,0,0.762,0.341,0.762,0.762s-0.34,0.762-0.762,0.762H4.157
                      C3.736,11.906,3.395,11.565,3.395,11.145z M3.395,17.238c0-0.421,0.341-0.762,0.762-0.762h7.592c0.421,0,0.762,0.341,0.762,0.762
                      S12.17,18,11.749,18H4.157C3.736,18,3.395,17.659,3.395,17.238z M14.795,21.047c0.422,0,0.762,0.341,0.762,0.762
                      s-0.34,0.762-0.762,0.762h-4.57c-0.421,0-0.762-0.341-0.762-0.762s0.341-0.762,0.762-0.762H14.795z M4.157,8.859
                      c-0.421,0-0.762-0.341-0.762-0.762s0.341-0.762,0.762-0.762h10.639c0.422,0,0.762,0.341,0.762,0.762s-0.34,0.762-0.762,0.762
                      H4.157z"/>
                  </g>
                </g>
                <g>
                  <g>
                    <path d="M15.639,16.111L14.976,18.1c-0.099,0.298,0.185,0.581,0.481,0.481l1.988-0.663L15.639,16.111z"/>
                  </g>
                </g>
                <g>
                  <g>
                    <path d="M21.555,9.84l-5.017,5.017l2.164,2.163c1.134-1.134,3.339-3.34,5.017-5.017L21.555,9.84z"/>
                  </g>
                </g>
                <g>
                  <g>
                    <path d="M25.9,7.655c-0.268-0.27-0.662-0.423-1.08-0.423s-0.813,0.154-1.082,0.424l-1.107,1.107l2.164,2.163
                      c0.605-0.606,1.025-1.025,1.107-1.107C26.496,9.223,26.496,8.252,25.9,7.655z"/>
                  </g>
                </g>
                <g>
                  <g>
                    <g>
                      <path d="M25.902,9.819L25.902,9.819c0.002-0.002,0.002-0.003,0.004-0.004C25.904,9.816,25.904,9.817,25.902,9.819z"/>
                      <path d="M25.906,9.814c0.002-0.002,0.006-0.005,0.006-0.007C25.912,9.809,25.908,9.812,25.906,9.814z"/>
                      <path d="M25.912,9.808C25.918,9.803,25.918,9.803,25.912,9.808L25.912,9.808z"/>
                    </g>
                  </g>
                </g>
              </svg>
              <i :class="favourite.st_class_name" aria-hidden="true" v-else></i>
              </div>
              <span>{{
                $t(`attributes['${favourite["st_control_name"]}']`)
              }}</span>
              <span
                id="close"
                @click="
                  questUpdated === 1
                    ? $awn.confirm(
                        'Do you want to save current question first?',
                        callSaveMethod,
                        callCancelMethod
                      )
                    : delFav(favourite['in_control_id'], index)
                "
                >x</span
              >
            </a>
            <!-- Displays if empty favourites initially -->
            <!-- Do not add class element_sec_box, as drag is set to true on that -->
            <!-- <a v-if="favArray.length == 0" v-for="(index) in 3" href="#" class="empty_favourite">
              <label>Drag control here</label>
            </a>-->
          </draggable>
          <!-- </div> -->
        </div>
        <div v-for="control in apiData" class="colume_1_elements">
          <h3>{{ $t(`attributes['${control["in_control_title"]}']`) }}</h3>
          <!-- <div class="elements_sec"> -->
          <draggable
            @start="
              (drag = false),
                questUpdated === 1
                  ? $awn.confirm(
                      'Do you want to save current question first?',
                      callSaveMethod,
                      callCancelMethod
                    )
                  : (drag = true)
            "
            class="elements_sec"
            v-model="control['control_title_details']"
            :move.once="checkMove"
            :options="{
              group: { name: 'people', put: false, pull: 'clone' },
              sort: false,
            }"
          >
            <a
              ref="infavs"
              v-for="(controldata, index) in control['control_title_details']"
              :key="controldata['in_control_id']"
              :id="controldata['in_control_id']"
              href="#/"
              :class="
                [all.in_survey_type === 1 &&
                (controldata['in_control_id'] ==
                  vueQueControlConfig.CONTROL_PHOTO ||
                  controldata['in_control_id'] ===
                    vueQueControlConfig.CONTROL_QR_AND_BARCODE_READER ||
                    controldata['in_control_id'] ===
                    vueQueControlConfig.CONTROL_AUDIO || controldata['in_control_id'] ===
                    vueQueControlConfig.CONTROL_VIDEO )
                  ? 'elements_sec_box disable_mobile_control'
                  : 'elements_sec_box',
                  all.in_survey_type === 4 &&
                (controldata['in_control_id'] ==
                  vueQueControlConfig.CONTROL_LIST ||
                  controldata['in_control_id'] ==
                  vueQueControlConfig.CONTROL_TEXT ||
                  controldata['in_control_id'] ==
                  vueQueControlConfig.CONTROL_EMAIL ||
                  controldata['in_control_id'] ==
                  vueQueControlConfig.CONTROL_TERMS_AND_CONDITIONS ||
                  controldata['in_control_id'] ==
                  vueQueControlConfig.CONTROL_NUMBER ||
                  controldata['in_control_id'] ==
                  vueQueControlConfig.CONTROL_DATE ||
                  controldata['in_control_id'] ==
                  vueQueControlConfig.CONTROL_TIME ||
                  controldata['in_control_id'] ==
                  vueQueControlConfig.CONTROL_IMAGE ||
                  controldata['in_control_id'] ==
                  vueQueControlConfig.CONTROL_SIGNATURE ||
                  controldata['in_control_id'] ==
                  vueQueControlConfig.CONTROL_PHOTO ||
                  controldata['in_control_id'] ==
                  vueQueControlConfig.CONTROL_START_SCREEN ||
                  controldata['in_control_id'] ==
                  vueQueControlConfig.CONTROL_QR_AND_BARCODE_READER ||
                  controldata['in_control_id'] ==
                  vueQueControlConfig.CONTROL_AUDIO ||
                  controldata['in_control_id'] ==
                  vueQueControlConfig.CONTROL_VIDEO)
                  ? 'elements_sec_box  disable_kiosk_control'
                  : 'elements_sec_box']
              "
              :data-id="controldata['in_control_id']"
              :data-controlname="controldata['st_control_name']"
              :data-classname="controldata['st_class_name']"
              @dblclick="
                questUpdated === 1
                  ? $awn.confirm(
                      'Do you want to save current question first?',
                      callSaveMethod,
                      callCancelMethod
                    )
                  : addQuestionOnDoubleClick($event, controldata)
              "
            >
            <div class="element_content">
              <svg height="512pt" viewBox="0 0 512 512" width="512pt" xmlns="http://www.w3.org/2000/svg" v-if="controldata['in_control_id'] == vueQueControlConfig.CONTROL_TIME">
                <path d="m256 0c-141.164062 0-256 114.835938-256 256s114.835938 256 256 256 256-114.835938 256-256-114.835938-256-256-256zm121.75 388.414062c-4.160156 4.160157-9.621094 6.253907-15.082031 6.253907-5.460938 0-10.925781-2.09375-15.082031-6.253907l-106.667969-106.664062c-4.011719-3.988281-6.25-9.410156-6.25-15.082031v-138.667969c0-11.796875 9.554687-21.332031 21.332031-21.332031s21.332031 9.535156 21.332031 21.332031v129.835938l100.417969 100.414062c8.339844 8.34375 8.339844 21.824219 0 30.164062zm0 0"/>
              </svg>
              <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="501.5px" height="520.5px" viewBox="0 -8.5 501.5 520.5" enable-background="new 0 -8.5 501.5 520.5" xml:space="preserve" v-else-if="controldata['in_control_id'] == vueQueControlConfig.CONTROL_TERMS_AND_CONDITIONS">
                <path d="M370.961,229.68c0.852,0,1.699,0.012,2.551,0.027l0.219,0.004c4.777,0.086,9.516,0.395,14.207,0.906V56.41
                  c0-33.309-27.102-60.41-60.41-60.41H65.414C32.102-4,5,23.102,5,56.41v347.473c0,33.313,27.102,60.414,60.41,60.414h175
                  c-15.102-24.27-23.023-51.988-23.023-80.957C217.387,298.61,286.277,229.68,370.961,229.68z M221.656,94.637h89.523
                  c8.285,0,15,6.715,15,15s-6.715,15-15,15h-89.523c-8.281,0-15-6.715-15-15S213.375,94.637,221.656,94.637z M221.656,154.641h89.523
                  c8.285,0,15,6.715,15,15s-6.715,15-15,15h-89.523c-8.281,0-15-6.715-15-15S213.375,154.641,221.656,154.641z M171.281,365.656
                  H81.758c-8.285,0-15-6.715-15-15c0-8.281,6.715-15,15-15h89.523c8.281,0,15,6.719,15,15
                  C186.281,358.942,179.563,365.656,171.281,365.656z M171.281,304.649H81.758c-8.285,0-15-6.715-15-15s6.715-15,15-15h89.523
                  c8.281,0,15,6.715,15,15S179.563,304.649,171.281,304.649z M171.281,244.645H81.758c-8.285,0-15-6.715-15-15s6.715-15,15-15h89.523
                  c8.281,0,15,6.715,15,15S179.563,244.645,171.281,244.645z M171.281,184.641H81.758c-8.285,0-15-6.715-15-15s6.715-15,15-15h89.523
                  c8.281,0,15,6.715,15,15S179.563,184.641,171.281,184.641z M171.281,124.637H81.758c-8.285,0-15-6.715-15-15s6.715-15,15-15h89.523
                  c8.281,0,15,6.715,15,15S179.563,124.637,171.281,124.637z M206.656,229.645c0-8.285,6.719-15,15-15h43.117c8.285,0,15,6.715,15,15
                  s-6.715,15-15,15h-43.117C213.375,244.645,206.656,237.93,206.656,229.645z"/>
                <path d="M459.785,295.942c-23.023-23.43-53.773-36.656-86.582-37.234l-0.215-0.004c-0.676-0.012-1.352-0.023-2.027-0.023
                  c-68.691,0-124.574,55.922-124.574,124.66c0,27.301,8.664,53.227,25.051,74.98c23.785,31.574,60.059,49.68,99.523,49.68
                  c68.691,0,124.574-55.922,124.574-124.66C495.535,350.434,482.84,319.395,459.785,295.942z M424.188,363.074l-47.57,59.301
                  c-2.957,3.684-7.309,5.617-11.711,5.617c-3.059,0-6.137-0.934-8.793-2.855l-35.48-25.707c-6.707-4.859-8.207-14.238-3.344-20.949
                  c4.859-6.707,14.238-8.207,20.945-3.344l23.918,17.328l38.637-48.164c5.184-6.461,14.621-7.496,21.086-2.313
                  C428.336,347.172,429.371,356.614,424.188,363.074z"/>
              </svg>
              <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="26.688px" height="26.563px" viewBox="0 -0.563 26.688 26.563" enable-background="new 0 -0.563 26.688 26.563" xml:space="preserve" v-else-if="controldata['in_control_id'] == vueQueControlConfig.CONTROL_SIGNATURE">
                <g>
                  <g>
                    <path d="M20.127,4.158c0-0.61-0.237-1.184-0.669-1.616l-2.154-2.154c-0.425-0.425-1.029-0.669-1.63-0.669h-0.131v4.57h4.584V4.158
                      L20.127,4.158z"/>
                  </g>
                </g>
                <g>
                  <g>
                    <path d="M14.258,15.438c0.146-0.443,0.4-0.855,0.732-1.189l5.158-5.136V5.813h-5.354c-0.42,0-0.736-0.341-0.736-0.762v-5.332
                      H2.633c-1.26,0-2.285,1.025-2.285,2.285v21.43c0,1.26,1.025,2.285,2.285,2.285h15.209c1.261,0,2.307-1.025,2.307-2.285v-5.686
                      l-0.838,0.817c-0.339,0.336-0.736,0.581-1.184,0.73l-2.422,0.809l-0.369,0.021c-0.61,0-1.188-0.297-1.546-0.795
                      c-0.355-0.494-0.452-1.135-0.259-1.715L14.258,15.438z M4.157,13.43h7.592c0.421,0,0.762,0.341,0.762,0.762
                      s-0.34,0.762-0.762,0.762H4.157c-0.421,0-0.762-0.341-0.762-0.762S3.736,13.43,4.157,13.43z M3.395,11.145
                      c0-0.421,0.341-0.762,0.762-0.762h7.592c0.421,0,0.762,0.341,0.762,0.762s-0.34,0.762-0.762,0.762H4.157
                      C3.736,11.906,3.395,11.565,3.395,11.145z M3.395,17.238c0-0.421,0.341-0.762,0.762-0.762h7.592c0.421,0,0.762,0.341,0.762,0.762
                      S12.17,18,11.749,18H4.157C3.736,18,3.395,17.659,3.395,17.238z M14.795,21.047c0.422,0,0.762,0.341,0.762,0.762
                      s-0.34,0.762-0.762,0.762h-4.57c-0.421,0-0.762-0.341-0.762-0.762s0.341-0.762,0.762-0.762H14.795z M4.157,8.859
                      c-0.421,0-0.762-0.341-0.762-0.762s0.341-0.762,0.762-0.762h10.639c0.422,0,0.762,0.341,0.762,0.762s-0.34,0.762-0.762,0.762
                      H4.157z"/>
                  </g>
                </g>
                <g>
                  <g>
                    <path d="M15.639,16.111L14.976,18.1c-0.099,0.298,0.185,0.581,0.481,0.481l1.988-0.663L15.639,16.111z"/>
                  </g>
                </g>
                <g>
                  <g>
                    <path d="M21.555,9.84l-5.017,5.017l2.164,2.163c1.134-1.134,3.339-3.34,5.017-5.017L21.555,9.84z"/>
                  </g>
                </g>
                <g>
                  <g>
                    <path d="M25.9,7.655c-0.268-0.27-0.662-0.423-1.08-0.423s-0.813,0.154-1.082,0.424l-1.107,1.107l2.164,2.163
                      c0.605-0.606,1.025-1.025,1.107-1.107C26.496,9.223,26.496,8.252,25.9,7.655z"/>
                  </g>
                </g>
                <g>
                  <g>
                    <g>
                      <path d="M25.902,9.819L25.902,9.819c0.002-0.002,0.002-0.003,0.004-0.004C25.904,9.816,25.904,9.817,25.902,9.819z"/>
                      <path d="M25.906,9.814c0.002-0.002,0.006-0.005,0.006-0.007C25.912,9.809,25.908,9.812,25.906,9.814z"/>
                      <path d="M25.912,9.808C25.918,9.803,25.918,9.803,25.912,9.808L25.912,9.808z"/>
                    </g>
                  </g>
                </g>
              </svg>
              <i :class="controldata.st_class_name" aria-hidden="true" v-else></i>
            </div>
              <span>{{
                $t(`attributes['${controldata["st_control_name"]}']`)
              }}</span>
              <span
                id="addedFav"
                v-if="favIds.includes(controldata['in_control_id'])"
              >
                <i
                  class="fa fa-heart active"
                  :id="controldata['in_control_id']"
                  aria-hidden="true"
                  @click="
                    questUpdated === 1
                      ? $awn.confirm(
                          'Do you want to save current question first?',
                          callSaveMethod,
                          callCancelMethod
                        )
                      : checkDelFavIcon($event)
                  "
                ></i>
              </span>
              <span id="addFav" v-else>
                <i
                  class="fa fa-heart"
                  :id="controldata['in_control_id']"
                  aria-hidden="true"
                  @click="
                    questUpdated === 1
                      ? $awn.confirm(
                          'Do you want to save current question first?',
                          callSaveMethod,
                          callCancelMethod
                        )
                      : checkFavIconClick($event, controldata)
                  "
                ></i>
              </span>
            </a>
          </draggable>
          <!-- </div> -->
        </div>
      </div>
    </div>
  </div>
  <!-- </v-wait> -->
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { EventBus } from "../../main";
import draggable from "vuedraggable";
var {
  queControlConfig,
  constantCommonConfig,
} = require("../../../config/config.js");
export default {
  name: "questionsleft",
  components: {
    draggable,
  },
  data() {
    return {
      apiData: [],
      favouritesData: [],
      favIds: [],
      // Only fav control details no details of favourite table
      favArray: [],
      sessionData: [],
      vueQueControlConfig: queControlConfig,
      vueCommonConfig: constantCommonConfig,
      // dragging: false,
      // targetElement: null,
      // canDrag:null,
      // futureIndex:null
    };
  },
  computed: {
    // for icons above start screen
    ...mapGetters("editquestionEdit", {
      questUpdated: "questionUpdated",
      skipLogicEndQ: "skipLogicEndQ",
    }),
    ...mapGetters("LeftSidebarCreate", [
      "all",
      "questionControls",
      "areControlsLoaded",
    ]),
  },
  async created() {
    // add condition heree
    this.sessionData = this.$session.getAll();
    this.sessionData["in_survey_Id"] = this.$route.params.id;
    if (!this.areControlsLoaded) {
      await this.getQuestionControls(this.sessionData).then((value) => {
        this.apiData = this.questionControls.data;
        this.favouritesData = this.questionControls.favouritesData;
        if (this.favouritesData && this.favouritesData.length > 0) {
          this.favouritesData.forEach(
            function (val, key) {
              this.favArray.push(val["control_details"]);
              this.favIds.push(val["in_control_id"]);
            }.bind(this)
          );
        }
      });
    } else {
      this.apiData = this.questionControls.data;
      this.favouritesData = this.questionControls.favouritesData;
      this.favouritesData.forEach(
        function (val, key) {
          this.favArray.push(val["control_details"]);
          this.favIds.push(val["in_control_id"]);
        }.bind(this)
      );
    }
  },
  methods: {
    ...mapActions("LeftSidebarCreate", [
      "getQuestionControls",
      "addFavourite",
      "removeFavourite",
    ]),
    callSaveMethod: function () {
      EventBus.$emit("saveQuestionFromCenterQuestions");
    },
    callCancelMethod: function () {
      EventBus.$emit("cancelQuestionFromCenterQuestions");
    },
    checkMove(event) {
      //console.log('Move Event');

      console.log(event.dragged.innerHTML);

      if (
        event.dragged.isdragged == "yes" ||
        this.favIds.includes(+event.dragged.id)
      ) {
        if (event.draggedContext.futureIndex > this.skipLogicEndQ - 1) {
          // For dragging from left component to center component
          if (
            (event.to.className == "dragArea icon-edit" ||
              event.to.className ==
                "dragArea icon-edit dragAreaMessage mtop50" ||
              event.to.className ==
                "temp-drag-box dragArea icon-edit dragAreaMessage" ||
              event.to.className ==
                "temp-drag-box dragArea icon-edit dragAreaMessage mtop50") &&
            !(
              this.all.in_survey_type == 1 &&
              (event.dragged.id == 11 || event.dragged.id == 13 || event.dragged.id == 19 || event.dragged.id == 20)
            )
          ) {
            return true;
          } else return false;
        } else {
          return false;
          this.$awn.alert("You cannot add question at this position");
        }
      } else {
        if (event.draggedContext.futureIndex > this.skipLogicEndQ - 1) {
          if (
            this.all.in_survey_type == 1 &&
            (event.dragged.id == 11 || event.dragged.id == 13 || event.dragged.id == 19 || event.dragged.id == 20)
          )
            return false;
          else return true;
        } else {
          return false;
          this.$awn.alert("You cannot add question at this position");
        }
      }
    },
    checkMoveOfFavs(event) {

      if (event.draggedContext.futureIndex > this.skipLogicEndQ - 1) {
        if (
          this.all.in_survey_type == 1 &&
          (event.dragged.id == 11 || event.dragged.id == 13 || event.dragged.id == 19 || event.dragged.id == 20)
        ) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
        this.$awn.alert("You cannot add question at this position");
      }
    },
    checkFavIconClick(event, controldata) {
      if (!this.favIds.includes(controldata.in_control_id)) {
        // this.favIds.push(+event.target.id);
        var temp = {
          st_control_name: controldata.st_control_name,
          st_class_name: controldata.st_class_name,
          in_control_id: controldata.in_control_id,
        };
        this.favArray.push(temp);
        temp["item"] = {};
        temp["item"]["id"] = temp["in_control_id"];
        this.onAdd(temp);
      }
    },
    checkDelFavIcon(event) {
      this.favArray.forEach(
        function (value, key) {
          if (value.in_control_id == +event.target.id) {
            this.delFav(+event.target.id, key);
          }
        }.bind(this)
      );
    },
    onAdd: function (/** Event */ evt) {
      this.favIds.push(+evt.item.id);
      // Set property if item already added once
      if (evt.item) {
        evt.item.isdragged = "yes";
      }
      this.sessionData["controlId"] = evt.item.id;
      this.addFavourite(this.sessionData);
    },
    delFav(control_id, index) {
      // For setting property isdraaged to No again on delete
      this.$refs.infavs.forEach(function (value, key) {
        if (value.id == control_id) {
          value.isdragged = "no";
        }
      });
      this.favArray.splice(index, 1);
      var index = this.favIds.indexOf(control_id);
      if (index > -1) {
        this.favIds.splice(index, 1);
      }
      this.sessionData["controlId"] = control_id;
      this.removeFavourite(this.sessionData);
    },
    addQuestionOnDoubleClick(evt, controldata) {
      var id = controldata['in_control_id'];
      if (
        this.all.in_survey_type === 1 &&
        (id === this.vueQueControlConfig.CONTROL_PHOTO ||
          id === this.vueQueControlConfig.CONTROL_QR_AND_BARCODE_READER ||
          id === this.vueQueControlConfig.CONTROL_AUDIO ||
          id === this.vueQueControlConfig.CONTROL_VIDEO)
      ) {
        return false;
      } else {
        var evt = {
          added: {
            element: {
              in_control_id: id,
              st_class_name: controldata['st_class_name'],
              st_control_name: controldata['st_control_name'],
              in_is_mobile_control:
                id == this.vueQueControlConfig.CONTROL_PHOTO ||
                id == this.vueQueControlConfig.CONTROL_QR_AND_BARCODE_READER ||
                id == this.vueQueControlConfig.CONTROL_AUDIO ||
                id == this.vueQueControlConfig.CONTROL_VIDEO
                  ? 1
                  : 0,
              is_double_clicked: true,
            },
          },
        };
        EventBus.$emit("addQuestionOnDbClick", evt);
      }
    },
  },
};
</script>
<style type="text/css" scoped="">
  #test {
    text-align: center;
    margin: 0 auto;
  }

  #test span {
    margin: 0;
    padding: 0;
    min-width: 680px;
    display: inline-block !important;
    padding-left: 20px;
  }

  #test i {
    margin: 0px;
    padding: 0;
    display: inline-block !important;
    min-width: 70px;
    text-align: right;
  }

  #test i.icomoon-dual {
    width: 60px !important;
    font-size: 14px;
  }

  #test i.icomoon-dual + span {
    margin: 0px;
    padding: 0;
    display: inline-block !important;
    padding-left: 15px;
  }

  #test i.fa-file-alt {
    width: 65px !important;
  }

  #test i.fa-file-alt + span {
    display: inline-block !important;
    padding-left: 10px;
  }

  #test #addFav {
    display: none !important;
  }

  .dragArea.icon-edit .elements_sec_box #test {
    width: auto;
    display: flex;
    justify-content: start;
    align-items: center;
  }

  .dragArea.icon-edit #test .element_content {
    min-width: auto;
    margin: 0 18px 0 42px;
  }

  .dragArea.icon-edit #test .element_content i {
    font-size: 20px;
    min-width: auto !important;
    width: auto !important;
  }

  .dragArea.icon-edit #test .element_content svg {
    fill: #8c8c8c;
  }

  .dragArea.icon-edit #test span {
    min-width: auto;
    padding: 0;
    text-align: center;
    width: auto;
  }

  .sortable-chosen.sortable-ghost #close{
    display: none !important;
  }
  
  .dragArea.icon-edit .element_content {
    min-width: auto;
    margin: 0 18px 0 42px;
  }

  .dragArea.icon-edit .element_content i {
    font-size: 20px;
    min-width: auto !important;
    width: auto !important;
  }

  .dragArea.icon-edit .element_content svg {
    fill: #8c8c8c;
  }



</style>


// WEBPACK FOOTER //
// src/components/Dashboard/questionsleft.vue